module.exports = __webpack_public_path__ + "img/sql_server-data-tools.0c50a738.svg";